const SIDEPANEL_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

window.Sidepanel = {
  open({ size = SIDEPANEL_SIZE.MEDIUM, showLoader = false, content } = {}) {
    document.querySelector("body").setAttribute("data-sidepanel-size", size);

    document
      .querySelector("#j-sidepanel")
      .setAttribute("data-sidepanel-size", size);

    document
      .querySelector("#j-sidepanel")
      .setAttribute("data-show-loader", showLoader);

    if (content) {
      this.render(content);
    }

    if (window.ReactRailsUJS) {
      window.ReactRailsUJS.mountComponents("#j-sidepanel");
    }

    document.querySelector("body").setAttribute("data-sidepanel", "open");
  },
  close() {
    window.eventbus.emit(window.EVENTS.CLOSE_SIDEPANEL_REQUESTED);

    document.querySelector("body").removeAttribute("data-sidepanel");

    document.querySelector("body").removeAttribute("data-sidepanel-size");

    document
      .querySelector("#j-sidepanel")
      .removeAttribute("data-sidepanel-size");

    document
      .querySelector("#j-sidepanel")
      .classList.remove("generate_invoice--sidepanel");

    if (window.ReactRailsUJS) {
      window.ReactRailsUJS.unmountComponents("#j-sidepanel");
    }

    this.render("");
  },
  render(content) {
    $("#j-sidepanel .content").html(
      content,
    ); /* JQquery dependency, innerHTML does not execute inner script tags */

    document
      .querySelector("#j-sidepanel")
      .setAttribute("data-show-loader", false);
  },
};

document.addEventListener("click", ({ target }) => {
  if (target.closest(".sidepannel--container-close")) {
    Sidepanel.close();
  } else if (target.closest(".j-save-button")) {
    window.appRating();
  }
});

window.OpenSmallSidepannel = function OpenSmallSidepannel(content) {
  Sidepanel.open({
    size: SIDEPANEL_SIZE.SMALL,
    content,
  });
};

window.OpenMediumSidepannel = function OpenMediumSidepannel() {
  Sidepanel.open({
    size: SIDEPANEL_SIZE.MEDIUM,
  });
};

window.OpenLargeSidepannel = function OpenLargeSidepannel({ showLoader = false } = {}) {
  Sidepanel.open({
    size: SIDEPANEL_SIZE.LARGE,
    showLoader,
  });
};

window.CloseSecondSidepannel = function CloseSecondSidepannel() {
  Sidepanel.close();
};

window.CloseSmallSidepannelButton = function CloseSmallSidepannelButton() {
  Sidepanel.close();
};

window.CloseMediumSidepannelButton = function CloseMediumSidepannelButton() {
  Sidepanel.close();
};

window.CloseLargeSidepannelButton = function CloseLargeSidepannelButton() {
  Sidepanel.close();
};
